(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8196],{

/***/ 6438:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/[slug]",
      function () {
        return __webpack_require__(4932);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Topbanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9262);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function Topbanner(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default().top_banner),
            style: {
                backgroundImage: "url(".concat(props.bgImage, ")")
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default().banner_text),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container common_title text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: props.title
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 4932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(9755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./src/styles/pages/Blogs.module.scss
var Blogs_module = __webpack_require__(1746);
var Blogs_module_default = /*#__PURE__*/__webpack_require__.n(Blogs_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Topbanner/Topbanner.js
var Topbanner = __webpack_require__(6240);
;// CONCATENATED MODULE: ./src/data/roomsData.js
const roomsData = [
    {
        slug: "deluxe-room",
        roomsImage: "/images/deluxe-room.webp",
        roomName: "Deluxe Room",
        banner: "/images/deluxe-banner.png",
        metaTitle: "Book Deluxe Hotel Room in Shimla|The Twin Towers Hotel in Kufri, Shimla",
        metaDesc: "These are one of the best deluxe rooms in Kufri. There is high-speed Internet access (Wi-Fi), an LED TV, an electric kettle, an ironing board, and more.",
        shortDesc: "These spacious rooms (380 square feet) are equipped with all the latest conveniences and amenities for a relaxing and luxurious stay.",
        roomDesc: "Our spacious luxury rooms in Kufri, spanning 380 square feet, offer a perfect blend of comfort and elegance. As a 4-star hotel in Kufri, we provide world-class amenities, ensuring a relaxing stay. Each room features high-speed Internet access (Wi-Fi), an LED TV, an electric kettle, an ironing board, a wardrobe, a daily cleaning service, and a hairdryer. If you are looking for the best deluxe room in Kufri, our hotel is the perfect choice. Experience the finest hospitality at the best hotel in Kufri, where luxury and comfort meet to create an unforgettable experience.",
        roomsPrice: "6,000/night",
        gallery: {
            imageone: "/images/singleroom-gal-img1.png",
            imagetwo: "/images/singleroom-gal-img2.png",
            imagethree: "/images/singleroom-gal-img3.png",
            imagefour: "/images/deluxe-gal1.png",
            imagefive: "/images/deluxe-gal2.png"
        },
        amenities: [
            {
                title: "Tea & Coffee Maker",
                icon: "/icons/coffee-maker.svg"
            },
            {
                title: "LED TV",
                icon: "/icons/tv.svg"
            },
            {
                title: "Electric Safe",
                icon: "/icons/electric-safe.svg"
            },
            {
                title: "Free Wi-Fi",
                icon: "/icons/wifi.svg"
            },
            {
                title: "360 Sq Ft",
                icon: "/icons/area.svg"
            },
            {
                title: "Luxury Toiletries",
                icon: "/icons/luxury-toiletries.svg"
            }
        ],
        area: "360 Sq Ft",
        beds: "(3) bed's",
        guests: "(4) Guest's",
        SingleRoomSchema: "DeluxeRoomSchema"
    },
    {
        slug: "premier-room",
        roomsImage: "/images/premium-room.webp",
        roomName: "Premier Room",
        banner: "/images/premier-banner.png",
        metaTitle: "Book Luxury Premium Hotel Room in Shimla-The Twin Towers Hotel in Shimla",
        metaDesc: "These best premier rooms in Kufri, shimla are spacious measuring in at 380 square feet. They come with a king-sized bed and breath-taking views of the surrounding valley.",
        shortDesc: "These best premier rooms in Kufri are spacious measuring in at 380 square feet. They come with a king-sized bed and breath.",
        roomDesc: "The Twin Towers Hotel in Shimla offers the best premier rooms in Kufri, designed for comfort and luxury. These spacious rooms measure 380 square feet and feature a king-sized bed with breathtaking views of the surrounding valley. As the best hotel in Kufri, it provides top-notch amenities, including a stylish desk, an electric safe, free Wi-Fi, a cozy sitting area, and elegant hardwood flooring. The best room in Kufri also includes a spacious closet and ample storage. Whether visiting Shimla for leisure or business, these rooms ensure a relaxing and memorable stay. Experience unmatched hospitality and luxury in Kufri!",
        roomsPrice: "6,000/night",
        gallery: {
            imageone: "/images/premier-gal2.png",
            imagetwo: "/images/premier-gal1.png",
            imagethree: "/images/premier-gal3.png",
            imagefour: "/images/premier-gal4.png",
            imagefive: "/images/premier-gal5.png"
        },
        amenities: [
            {
                title: "Tea & Coffee Maker",
                icon: "/icons/coffee-maker.svg"
            },
            {
                title: "LED TV",
                icon: "/icons/tv.svg"
            },
            {
                title: "Electric Safe",
                icon: "/icons/electric-safe.svg"
            },
            {
                title: "Free Wi-Fi",
                icon: "/icons/wifi.svg"
            },
            {
                title: "360 Sq Ft",
                icon: "/icons/area.svg"
            },
            {
                title: "Luxury Toiletries",
                icon: "/icons/luxury-toiletries.svg"
            }
        ],
        area: "380 Sq Ft",
        beds: "(3) bed's",
        guests: "(4) Guest's",
        SingleRoomSchema: "PremierRoomSchema"
    },
    {
        slug: "executive-room",
        roomsImage: "/images/executive-room.webp",
        roomName: "Executive Room",
        banner: "/images/exec-banner.png",
        metaTitle: "Best Executive Hotel Room in Shimla| The Twin Towers Hotel in Shimla, Kufri",
        metaDesc: "These best executive rooms in Kufri are fully soundproof and include contemporary furnishings. Guests may enjoy modern conveniences including a keyless entry system",
        shortDesc: "These 380-square-feet rooms provide highly customized attention and maximum convenience. These best executive rooms in Kufri are fully soundproof",
        roomDesc: "The Twin Towers Hotel in Shimla, the best hotel in Kufri,  offers luxurious and spacious best executive rooms in Kufri designed for ultimate comfort. These 380-square-feet rooms provide highly customized attention and maximum convenience, ensuring a premium stay. Fully soundproof and equipped with contemporary furnishings, they create a peaceful retreat. Guests can enjoy modern amenities, including a keyless entry system, free Wi-Fi, a smart TV, and a tea and coffee maker. These Kufri rooms with balcony offer stunning views, allowing guests to unwind in nature’s beauty. As some of the best rooms with mountain views in Shimla, they provide breathtaking panoramas of ",
        roomsPrice: "6,000/night",
        gallery: {
            imageone: "/images/exec-gal1.png",
            imagetwo: "/images/exec-gal2.png",
            imagethree: "/images/exec-gal3.png",
            imagefour: "/images/exec-gal4.png",
            imagefive: "/images/exec-gal5.png"
        },
        amenities: [
            {
                title: "Tea & Coffee Maker",
                icon: "/icons/coffee-maker.svg"
            },
            {
                title: "LED TV",
                icon: "/icons/tv.svg"
            },
            {
                title: "Electric Safe",
                icon: "/icons/electric-safe.svg"
            },
            {
                title: "Free Wi-Fi",
                icon: "/icons/wifi.svg"
            },
            {
                title: "360 Sq Ft",
                icon: "/icons/area.svg"
            },
            {
                title: "Luxury Toiletries",
                icon: "/icons/luxury-toiletries.svg"
            }
        ],
        area: "80 Sq Mt",
        beds: "(3) bed's",
        guests: "(4) Guest's",
        SingleRoomSchema: "ExecutiveRoomSchema"
    },
    {
        slug: "family-suite-room",
        roomsImage: "/images/family-suite-room.webp",
        roomName: "Family Suite",
        banner: "/images/family-banner.png",
        metaTitle: "Book Family Suite Hotel Room In Shimla | The Twin Towers Hotel in Kufri, Shimla",
        metaDesc: "The special amenities in this room category are here to make your stay more enjoyable and productive making it the best family suite in Kufri",
        shortDesc: "Our 650-square-feet Family Suite has a classic design and a picturesque view of the mountains.",
        roomDesc: "The Family Rooms in Kufri at The Twin Towers Hotel in Shimla offer an unmatched blend of luxury and comfort. Our spacious 650-square-foot Family Suite boasts a classic design with breathtaking rooms with mountain views in Shimla. This 4-star hotel in Kufri ensures top-tier amenities, including a walk-in wardrobe, king-sized beds, a minibar, an electric safe, Wi-Fi, LED televisions, and modern bathrooms with premium toiletries. Enjoy an electronic key entrance for added security. Featuring Kufri rooms with a balcony, this suite guarantees a refreshing and scenic experience, making it the best hotel in Kufri for families seeking a memorable stay.",
        roomsPrice: "6,000/night",
        gallery: {
            imageone: "/images/family-gal1.png",
            imagetwo: "/images/family-gal2.png",
            imagethree: "/images/family-gal3.png",
            imagefour: "/images/family-gal4.png",
            imagefive: "/images/family-gal5.png"
        },
        amenities: [
            {
                title: "Tea & Coffee Maker",
                icon: "/icons/coffee-maker.svg"
            },
            {
                title: "LED TV",
                icon: "/icons/tv.svg"
            },
            {
                title: "Electric Safe",
                icon: "/icons/electric-safe.svg"
            },
            {
                title: "Free Wi-Fi",
                icon: "/icons/wifi.svg"
            },
            {
                title: "360 Sq Ft",
                icon: "/icons/area.svg"
            },
            {
                title: "Luxury Toiletries",
                icon: "/icons/luxury-toiletries.svg"
            }
        ],
        area: "650 Sq Ft",
        beds: "(3) bed's",
        guests: "(4) Guest's",
        SingleRoomSchema: "FamilyRoomSchema"
    }
];

// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(9583);
// EXTERNAL MODULE: ./node_modules/next-share/dist/next-share.es.js
var next_share_es = __webpack_require__(1818);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(7349);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInDays/index.js
var differenceInDays = __webpack_require__(7803);
// EXTERNAL MODULE: ./src/components/Loader/NewLoader.js
var NewLoader = __webpack_require__(4538);
;// CONCATENATED MODULE: ./src/components/BestDeal/BookNowButtonWhite.js








function BookNowButtonWhite(param) {
    let { setIsactive , style  } = param;
    const router = (0,next_router.useRouter)();
    const [loader, setLoader] = (0,react.useState)(false);
    const [noOfNights, setNoOfNights] = (0,react.useState)(router.query.npOfNights || 1);
    const [startDate, setStartDate] = (0,react.useState)(new Date());
    const [endDate, setEndDate] = (0,react.useState)(()=>{
        const tomorrow = (0,addDays["default"])(new Date(), 1);
        return tomorrow;
    });
    const [checkin, setCheckin] = (0,react.useState)({
        day: router.query.checkinDay || "",
        month: router.query.checkinMonth || "",
        year: router.query.checkinYear || ""
    });
    const [checkout, setCheckout] = (0,react.useState)({
        day: router.query.checkoutDay || "",
        month: router.query.checkoutMonth || "",
        year: router.query.checkoutYear || ""
    });
    (0,react.useEffect)(()=>{
        const updateDateState = (date, setStateFunction)=>{
            if (date !== null) {
                const day = date.getDate();
                const month = (date.getMonth() + 1).toString().padStart(2, "0");
                const year = date.getFullYear();
                setStateFunction({
                    day,
                    month,
                    year
                });
            }
        };
        updateDateState(startDate, setCheckin);
        updateDateState(endDate, setCheckout);
        const nights = moment_default()(endDate).diff(moment_default()(startDate), "days");
        setNoOfNights(nights > 0 ? nights : 1);
    }, [
        startDate,
        endDate
    ]);
    (0,react.useEffect)(()=>{
        const nights = (0,differenceInDays/* default */.Z)(endDate, startDate);
        setNoOfNights(nights);
    }, [
        startDate,
        endDate
    ]);
    const formated_start_date = moment_default()(startDate).format("YYYY-MM-DD");
    const formated_end_date = moment_default()(endDate).format("YYYY-MM-DD");
    const handleSetInactive = ()=>{
        if (setIsactive) {
            setIsactive(false);
        }
    };
    const handleSubmit = async (event, hotelId)=>{
        event.preventDefault();
        handleSetInactive();
        try {
            await router.push("/searchresults/?hotelID=".concat(hotelId, "&checkinDay=").concat(checkin.day, "&checkinMonth=").concat(checkin.month, "&checkinYear=").concat(checkin.year, "&checkoutDay=").concat(checkout.day, "&checkoutMonth=").concat(checkout.month, "&checkoutYear=").concat(checkout.year, "&room=1&adult=2&children=0&checkIn=").concat(formated_start_date, "&checkOut=").concat(formated_end_date, "&noOfNights=").concat(noOfNights), undefined, {
                shallow: false
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally{
            setLoader(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            className: "common_btn_white_bg",
            style: style,
            onClick: (event)=>handleSubmit(event, 17),
            children: "Book Now"
        })
    });
}

;// CONCATENATED MODULE: ./src/pages/blogs/[slug].js














var __N_SSG = true;
function Blog(param) {
    let { blog , Allblogs  } = param;
    let filteredBlogs = Allblogs.filter((item)=>item.slug !== blog.slug);
    const similar_blogs = filteredBlogs;
    const [copied, setCopied] = (0,react.useState)(false);
    const handleCopyLink = async ()=>{
        try {
            const fullUrl = window.location.href;
            await navigator.clipboard.writeText(fullUrl);
            setCopied(true);
            setTimeout(()=>setCopied(false), 3000);
        } catch (err) {
            console.error("Failed to copy: ", err);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: blog.metaTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.svg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: blog === null || blog === void 0 ? void 0 : blog.metaDesc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.hoteltwintowers.com/blogs/".concat(blog === null || blog === void 0 ? void 0 : blog.slug)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: blog === null || blog === void 0 ? void 0 : blog.metaKeywords
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (Blogs_module_default()).single_blog_top_banner
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "".concat((Blogs_module_default()).single_blog, " common_padding"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: 'col-12 col-sm-12 col-md-8 col-lg-8"',
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Blogs_module_default()).single_blog_page_top,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-left",
                                                children: [
                                                    "Publish on: ",
                                                    blog.date
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                children: blog.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((Blogs_module_default()).blog_social_links_parent, " d-flex"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "".concat((Blogs_module_default()).single_blog_destinations_btn, " d-flex"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                children: "Shimla"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                children: "Kufri"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                children: "Things To Do "
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            "Share On:",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "".concat((Blogs_module_default()).blog_page_social_links, " d-flex"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_share_es/* FacebookShareButton */.Dk, {
                                                                        url: "https://www.hoteltwintowers.com/blogs/".concat(blog.slug),
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_share_es/* FacebookIcon */.Vq, {
                                                                            size: 32,
                                                                            round: true
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_share_es/* InstapaperShareButton */.ht, {
                                                                        url: "https://www.hoteltwintowers.com/blogs/".concat(blog.slug),
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_share_es/* InstagramIcon */.yu, {
                                                                            size: 32,
                                                                            round: true
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_share_es/* WhatsappShareButton */.N0, {
                                                                        url: "https://www.hoteltwintowers.com/blogs/".concat(blog.slug),
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_share_es/* WhatsappIcon */.ud, {
                                                                            size: 32,
                                                                            round: true
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (Blogs_module_default()).link_icon,
                                                                        onClick: handleCopyLink,
                                                                        children: [
                                                                            copied && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                children: "Copied!"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaLink */.gjK, {})
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((Blogs_module_default()).blog_text1, " common_title"),
                                        dangerouslySetInnerHTML: {
                                            __html: blog.content
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((Blogs_module_default()).recent_blog_sec, " col-12 col-sm-12 col-md-4 col-lg-4"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Blogs_module_default()).sticky_recent_posts,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((Blogs_module_default()).recent_top, " common_title"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "text-white",
                                                    children: "Recent Posts"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Blogs_module_default()).recent_bottom,
                                                children: similar_blogs && similar_blogs.slice(0, 5).map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                        href: "/blogs/".concat(item.slug),
                                                        className: (Blogs_module_default()).recent_bottom_main,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: item.bgImage,
                                                                    alt: item.title,
                                                                    width: 70,
                                                                    height: 70
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Blogs_module_default()).recent_bottom_right,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: item.date
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                        className: "m-0",
                                                                        children: item.title
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, item.slug))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Blogs_module_default()).recent_blog_bottom_img_sec,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Blogs_module_default()).recent_blog_bottom_img,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: "/images/recent-blog-bottom.png",
                                                    layout: "fill"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Blogs_module_default()).recent_blog_bottom_img_content,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                                        children: [
                                                            "Experience",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            " Breathtaking Mornings!"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BookNowButtonWhite, {})
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Blogs_module_default()).blog_footer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Blogs_module_default()).blog_footer_content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "Your Perfect Stay Awaits"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BookNowButtonWhite, {})
                        ]
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 9262:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top_banner":"Topbanner_top_banner__iVW4z","banner_text":"Topbanner_banner_text__wm4dg"};

/***/ }),

/***/ 1746:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"single_blog_top_banner":"Blogs_single_blog_top_banner__BJmMQ","blogs":"Blogs_blogs__GHMzO","blog_top":"Blogs_blog_top__PnvhB","blog_top_img":"Blogs_blog_top_img__TEEWY","top_blog":"Blogs_top_blog__9s2wT","top_blog_image":"Blogs_top_blog_image__nwOQH","top_blog_content":"Blogs_top_blog_content___5dOg","all_blogs":"Blogs_all_blogs___z2VY","single_blog_parent":"Blogs_single_blog_parent__X_OP1","all_blog_image":"Blogs_all_blog_image__KwBr1","all_blog_content":"Blogs_all_blog_content__KaN21","blog_title":"Blogs_blog_title__2VT8r","blog_date":"Blogs_blog_date__mRo7f","single_blog":"Blogs_single_blog__2FkBD","single_blog_page_top":"Blogs_single_blog_page_top__Zkl9V","blog_social_links_parent":"Blogs_blog_social_links_parent__K_mXU","single_blog_destinations_btn":"Blogs_single_blog_destinations_btn__BB8yM","blog_page_social_links":"Blogs_blog_page_social_links__sCEer","link_icon":"Blogs_link_icon__TC7OZ","highlight_div":"Blogs_highlight_div__V92fw","h5_text":"Blogs_h5_text__rRZaB","images_sec":"Blogs_images_sec__hT6t6","blog_text1":"Blogs_blog_text1__weznr","recent_blog_sec":"Blogs_recent_blog_sec__38kjm","sticky_recent_posts":"Blogs_sticky_recent_posts__L_Xut","recent_top":"Blogs_recent_top__PYyfD","recent_bottom":"Blogs_recent_bottom__yhmBO","recent_bottom_main":"Blogs_recent_bottom_main__97XiQ","recent_bottom_right":"Blogs_recent_bottom_right__cCZsO","recent_blog_bottom_img_sec":"Blogs_recent_blog_bottom_img_sec__CpL5_","recent_blog_bottom_img":"Blogs_recent_blog_bottom_img__qSRIP","recent_blog_bottom_img_content":"Blogs_recent_blog_bottom_img_content__DE6hF","blog_footer":"Blogs_blog_footer__Zg8ce","blog_footer_content":"Blogs_blog_footer_content__p_bgS","blogs_sec":"Blogs_blogs_sec__qXez2","blogs_child":"Blogs_blogs_child__mB5qG","blog_child_image":"Blogs_blog_child_image__qUe27","blog_bottom":"Blogs_blog_bottom__8tl1F","read_more_btn":"Blogs_read_more_btn__6zQrg","button_sec":"Blogs_button_sec__y__xN","blog_page_btn":"Blogs_blog_page_btn__m1YUa"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1818,9774,2888,179], function() { return __webpack_exec__(6438); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);